import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ReactComponent as ProgramType } from "../../../../assets/svg/program-type.svg";
import { ReactComponent as Location } from "../../../../assets/svg/location-inside-circle.svg";
import { ReactComponent as Comment } from "../../../../assets/svg/comment.svg";
import { IconWithText } from "../../../program/components/IconWithText";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    rowGap: "16px",
  },
  container: {
    fontSize: 16,
    color: "#858997",
    fontWeight: 500,
    marginTop: 7,
    paddingLeft: 50,
  },
  countryContainer: {
    maxWidth: 500,
    wordBreak: "break-all",
  },
}));

interface PrivateClassSubInfoWidgetProps {
  subjectName: string;
  teachingLanguage: string;
  country: string;
}

export const PrivateClassSubInfoWidget: FC<PrivateClassSubInfoWidgetProps> = ({
  subjectName,
  teachingLanguage,
  country,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <IconWithText Icon={ProgramType} title="Subject Name" />
        <div className={classes.container}>{subjectName}</div>
      </div>
      <div>
        <IconWithText Icon={Comment} title="Teaching Language" />
        <div className={classes.container}>{teachingLanguage}</div>
      </div>
      <div className={classes.countryContainer}>
        <IconWithText Icon={Location} title="Country" />
        <div className={classes.container}>{country}</div>
      </div>
    </div>
  );
};
